export default __webpack_public_path__ + "static/icomoon-bd04c7f9ee191aeff91b1c6ab7eb6a9d.woff";